export enum ERROR_CODE {
  TIME_OUT = 'timeout',
  NOT_AUTHORIZE = 'authentication.notauthorize',
}